var template_name = template_name;
var pro_price = pro_price;

function updatePrice() {
  var quantity_selected = $('input[name=Quantity]:checked').val();
  var quantity = 1;
  if (quantity_selected.endsWith(' Bottles')) {
    quantity = parseInt(quantity_selected.replace(' Bottles', ''));
  }
  var variant_price = $('.product_price_main_div').find('.custom_price').text();
  var radio_selected = $('input[name=bold-ro__selector_radio_button]:checked').val();
  var pri = parseFloat(variant_price.replace('$', ''));

  var smart_ship_dis_price = parseFloat(((pri * 10) / 100).toFixed(2));
  var main_price = parseFloat(pri - smart_ship_dis_price).toFixed(2);

  var price_per_bottle = pri / quantity;
  var price_per_bottle_original = parseFloat($('.proprice').attr('data-currency-original').replace('$', '').replace(' USD', ''));
  var multi_bottle_dis_price = parseFloat((quantity * price_per_bottle_original - pri).toFixed(2));

  var total_smart_ship_dis_price = smart_ship_dis_price + multi_bottle_dis_price;

  if (radio_selected == "0") {
    $('.smart_ship_price').hide();
    $('.proprice').text(variant_price);
    $('.one_time_pro_price_original').text('$' + price_per_bottle_original.toFixed(2));
    $('.one_time_pro_price').text('$' + price_per_bottle.toFixed(2));
    $('.one_time_dis_price').text('$' + multi_bottle_dis_price.toFixed(2));
    $('.one_time_pro_price_original').css('display', quantity > 1 ? 'inline' : 'none');
    $('.one_time_dis_price_wrapper').css('display', quantity > 1 ? 'block' : 'none');
    $('.one_time_save_more_with').css('display', quantity > 1 ? 'inline' : 'none');
    $('.save_price').text("$" + smart_ship_dis_price.toFixed(2));
    $('.one_time_price').show();
  }
  if (radio_selected == "2") {
    $('.one_time_price').hide();
    $('.main_price').text(variant_price);
    $('.dis_amt').text("$" + main_price + " USD");
    $('.saving_amt').text("Total Savings: $" + total_smart_ship_dis_price.toFixed(2));
    $('.smart_ship_price').show();
  }
}




function updatePrice_for_cart() {
  var quantity_selected = $('input[name=Quantity]:checked').val();
  var quantity = 1;
  if (quantity_selected.endsWith(' Bottles')) {
    quantity = parseInt(quantity_selected.replace(' Bottles', ''));
  }
  var variant_price = $('.product_price_main_div').find('.custom_price').text();
  var radio_selected = $('input[name=bold-ro__selector_radio_button]:checked').val();
  var pri = parseFloat(variant_price.replace('$', ''));

  var smart_ship_dis_price = parseFloat(((pri * 10) / 100).toFixed(2));
  var main_price = parseFloat(pri - smart_ship_dis_price).toFixed(2);

  var price_per_bottle = pri / quantity;
  var price_per_bottle_original = parseFloat($('.proprice').attr('data-currency-original').replace('$', '').replace(' USD', ''));
  var multi_bottle_dis_price = parseFloat((quantity * price_per_bottle_original - pri).toFixed(2));

  var total_smart_ship_dis_price = smart_ship_dis_price + multi_bottle_dis_price;

  if (radio_selected == "0") {
    $('.smart_ship_price').hide();
    $('.proprice').text(variant_price);
    $('.one_time_pro_price_original').text('$' + price_per_bottle_original.toFixed(2));
    $('.one_time_pro_price').text('$' + price_per_bottle.toFixed(2));
    $('.one_time_dis_price').text('$' + multi_bottle_dis_price.toFixed(2));
    $('.one_time_pro_price_original').css('display', quantity > 1 ? 'inline' : 'none');
    $('.one_time_dis_price_wrapper').css('display', quantity > 1 ? 'block' : 'none');
    $('.one_time_save_more_with').css('display', quantity > 1 ? 'inline' : 'none');
    $('.save_price').text("$" + smart_ship_dis_price.toFixed(2));
    $('.one_time_price').show();
  }
  if (radio_selected == "2") {
    $('.one_time_price').hide();
    $('.main_price').text(variant_price);
    $('.dis_amt').text("$" + main_price + " USD");
    $('.saving_amt').text("Total Savings: $" + total_smart_ship_dis_price.toFixed(2));
    $('.smart_ship_price').show();
  }
}




$(document).ready(function () {
  if (template_name == "product" ) {
    setTimeout(updatePrice, 1000);

    $('input[name=Quantity]').on('click', function () {
      setTimeout(updatePrice, 300);
    });

    $(document).on('click', 'input[name=bold-ro__selector_radio_button]', updatePrice);
  }
  
  if(template_name =="cart") {
    setTimeout(updatePrice_for_cart, 1000);

    $('input[name=Quantity]').on('click', function () {
      setTimeout(updatePrice_for_cart, 300);
    });

    $(document).on('click', 'input[name=bold-ro__selector_radio_button]', updatePrice_for_cart);
  }

  $('.product_mobile_slider').slick({
    dots: false,
    arrows: true,
    draggable: false
  });


  $('.flip-card').click(function () {
    //     debugger;
    $(this).addClass('active');
    $(this).parent(".collection--item").find('.remove_btn').css('display', 'block');
  })

  $('.remove_btn').click(function () {
    $(this).parent(".collection--item").find('.flip-card').removeClass('active');
    $(this).css('display', 'none');
  });


  $('.dynamicCart').on("click", function (e) {
    debugger;
    e.preventDefault();
    var quantity = 1;
    var id = $(this).parent().children('.cvariant_id').val();
    $.ajax({
      url: "/cart/add.js",
      type: "post",
      dataType: 'json',
      data: { quantity: quantity, id: id },
      success: function () {
        window.location.href = "/cart";
      }
    });
  });
  
  
  $(".edit_me").click(function(){
  	var item_id = $(this).data("item");
    $("#"+item_id).fadeIn(200);
  });
  
  $(".closeme").click(function(){
  	
    $(this).parents(".edit_product_modal").fadeOut(200);
  });
  
  $(".form_edit_cart_btn").click(function(e){
  	e.preventDefault();
    $(this).addClass("processing");
    var line = $(this).data("lineitem");
    
     $.ajax({
      url: "/cart/change.js",
      type: "post",
      dataType: 'json',
      data: { quantity: 0, line: line },
      success: function () {
        $("#line_item_"+ line + " form").submit();
      }
    
    
  });
  });
  
   $('.edit_product_modal input.custom_option_input').change(function(){
        var val = $(this).val();
     console.log(val);
     
     $(this).parents("form").find("select[name='id']").find("option[data-value='"+val+"']").attr('selected', 'selected');
       
    });

});

/* EasyTabs custom */
document.addEventListener('easytabs_page_inited', function (e) {
  if (easytabs.activeTabHash){
  	let activeTab = $('li[data-et-marker="' + easytabs.activeTabHash + '"],li[data-et-handle="' + easytabs.activeTabHash + '"]');
    if (activeTab){
    	if ('scrollRestoration' in history) {history.scrollRestoration = 'manual';}
      	$('html, body').animate({ scrollTop: activeTab.offset().top }, 500);
    }
  }
   $('.reviews-anchor a').on('click', function () { $('html, body').animate({ scrollTop: $('li[data-et-marker="' + $(this).attr('href').replace("#", "") + '"]').offset().top }, 500); });
  });
/* EasyTabs custom */